export default "__VITE_ASSET__e9c4ea65__"